import(flu.chunks.swiper).then(_ref => {
  let {
    Swiper,
  } = _ref;
  
  const swiper = new Swiper('.our-social-wrapper', {
    speed: 400,
    slidesPerView: 1.108,
    spaceBetween: 16,
    breakpoints: {
      640: {
        slidesPerView: 1.6,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2.1,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3.1,
        spaceBetween: 16,
      },
      1200: {
        slidesPerView: 3.9165,
        spaceBetween: 28,
      }
    }
  });
});